import { create } from "zustand";
import { useCourseDetailStore } from "@/stores/courseDetailStore";
import { collectDecks, type Deck } from "@/services/flashcardsService";

type FlashcardsView = "deckPicker";

interface FlashcardsState {
  view: FlashcardsView | null;
  decks: Deck[];
  decksLoading: boolean;
  decksError: string | null;
  open: () => void;
  close: () => void;
  loadDecks: (enrollmentId: string) => Promise<void>;
}

export const useFlashcardsStore = create<FlashcardsState>((set) => ({
  view: null,
  decks: [],
  decksLoading: false,
  decksError: null,

  open: () => set({ view: "deckPicker" }),
  close: () => set({ view: null }),

  loadDecks: async (enrollmentId: string) => {
    set({ decksLoading: true, decksError: null });
    try {
      const courseStore = useCourseDetailStore.getState();
      if (
        !courseStore.courseData ||
        courseStore.enrollmentId !== enrollmentId
      ) {
        await courseStore.fetchCourse(enrollmentId);
      }
      const { courseData, completedContentElementIds } =
        useCourseDetailStore.getState();
      if (!courseData) {
        throw new Error("Kursstruktur konnte nicht geladen werden");
      }
      const decks = await collectDecks(courseData, completedContentElementIds);
      set({ decks, decksLoading: false });
    } catch (err) {
      set({
        decksError: err instanceof Error ? err.message : "Unbekannter Fehler",
        decksLoading: false,
      });
    }
  },
}));
